import {
  FB_EVT_STREAMED_EPISODE_START,
  FB_EVT_STREAMED_EPISODE
} from '@/config/events-fb-pixel/events';
import {
  FB_META_PERCENTAGE_PROGRESS,
  FB_META_SHOW_TITLE,
  FB_META_TOTAL_LISTENING_TIME
} from '@/config/events-fb-pixel/metadata';

export const FBstreamedEpisodeStart = ({ showTitle }) => ({
  eventName: FB_EVT_STREAMED_EPISODE_START,
  metadata: { [FB_META_SHOW_TITLE]: showTitle }
});

export const FBstreamedEpisode = ({
  showTitle,
  percentageProgress,
  totalListeningTimeSeconds
}) => ({
  eventName: FB_EVT_STREAMED_EPISODE,
  metadata: {
    [FB_META_SHOW_TITLE]: showTitle,
    [FB_META_PERCENTAGE_PROGRESS]: percentageProgress,
    [FB_META_TOTAL_LISTENING_TIME]: totalListeningTimeSeconds
  }
});